import database from '../../firebase/firebase';

// Connect to segment analytics
import { EventTypes } from 'redux-segment';

// import UserFactory from '../../classes/UserFactory';
import SearchService from '../../classes/SearchService';
import Estimation from '../../classes/Estimation';
import Filter from '../../classes/Filter';
import Shop from '../../classes/Shop';
import Bike360 from '../../classes/Bike360';
import { setBikeWillLast } from './UserActions';

import formatRange from '../../functions/formatRange';
import getDueHeight from '../../functions/getDueHeight';
// import getExternalLink from '../../functions/getExternalLink';

const searchService = new SearchService();

const defaultValue = searchService.getHeightRange().min;
const defaultBike = searchService.defaultBike();

const minRiderHeight = searchService.getHeightRange().min;
const maxRiderHeight = searchService.getHeightRange().max;
const inchToCMIndex = 2.54;

const defaultColor = searchService.defaultBike().colors[0];

const matchCurrentBike = (value, unit, folder) => {

    const filter = new Filter(value, unit, folder);
    const bike = searchService.matchBike(filter);

    return bike;
};

const setValue = ({ rangeValue = defaultValue } = {}) => ({
    type: 'SET_VALUE',
    rangeValue
});

const setColor = ({ color = defaultColor }) => ({
    type: 'SET_COLOR',
    color
});

const setBike = ({ bike = defaultBike }) => ({
    type: 'SET_BIKE',
    bike
});

const setEstimatedHeight = ({ estimatedHeight }) => ({
    type: 'SET_ESTIMATED_HEIGHT',
    estimatedHeight    
});

const trackSegmentBike = ({ user }, { bike = defaultBike }, { nextBike = '' }, { bikeDueDate = '' }, { estimatedHeight }, num ) => {

    const estimatedHeightKey = `estimatedHeight_${num}`;

    const heightChild = `height_${num}`;
    const sizeChild = `size_${num}`;
    const colorChild = `color_${num}`;
    const nextBikeKey = `nextBike_${num}`;
    const bikeDueDateKey = `bikeDueDate_${num}`;

    return {
        type: 'TRACK_SEGMENT_BIKE',
        meta: {
            analytics: {
                eventType: EventTypes.identify,
                eventPayload: {
                    userId: user.id,
                    traits: {
                        [estimatedHeightKey]: estimatedHeight,
                        [heightChild]: bike.height,
                        [sizeChild]: bike.wheel,
                        [colorChild]: bike.color,
                        [nextBikeKey]: nextBike,
                        [bikeDueDateKey]: bikeDueDate
                    }
                },
            },
        },
    }

};

const setEstimatedHeightNum = ({ estimatedHeight }) => {
    return {
        type: 'SET_ESTIMATED_HEIGHT',
        estimatedHeight
    }
};

const setFinalBike = ({ bike = defaultBike }) => {
    return {
        type: 'SET_FINAL_BIKE',
        bike
    }

};

// unit tracker Segment
const setUnit = ({ unit = 'inches' }) => ({
    type: 'SET_UNIT',
    unit
});

const setUnitDatabase = ({ unit = 'inches' }) => {

    return (dispatch, getValue) => {

        const id = getValue().user.user.id;

        dispatch(setUnit({ unit }));
        return database.ref(`user_${id}/bike/unit`).set(unit);
    }

};

const setLink = ({ link }) => ({
    type: 'SET_LINK',
    link
});


const setLinkDatabase = ({ link }) => {

    return (dispatch, getValue) => {

        const id = getValue().user.user.id;
        dispatch(setLink({ link }));
        return database.ref(`user_${id}/link`).set(link);
    }

};

const setBikeDueDate = ({ bikeDueDate = '' }) => ({
        type: 'SET_BIKE_DUE_DATE',
        bikeDueDate
    });

const setBikeDueDateNum = ({ bikeDueDate = '' }, num) => {

    return {
        type: 'SET_BIKE_DUE_DATE',
        bikeDueDate
    }
};

const setNextBike = ({ nextBike = '' }) => {
    return {
        type: 'SET_NEXT_BIKE',
        nextBike
    }
};

const setBikeDatabase = ({ bike }) => {

    return (dispatch, getValue) => {

        const id = getValue().user.user.id;
        const params = getValue().user.params;

        const height = bike.height;
        const wheel = bike.wheel;
        const color = bike.color;
        const type = bike.type;

        // const userId = getValue().user.id; 

        const url360 = new Bike360(bike, color);
        const imgGlobal = url360.getGlobalSRC();
        const link = new Shop(bike, color).getShopURL(params);
        // const link24Bike = new Shop(24, color).getShopURL();

        const bikeOptions = {
            height:
                {
                    inches: Math.floor(height),
                    cm: Math.floor(height * 2.54),
                    feetAndInches: `${Math.trunc(height / 12)} feets ${height % 12} inches`
                }
            ,
            wheel,
            imgGlobal,
            link,
            // link24Bike,
            color,
            type
        };

        const bikeDueDate = getValue().bike.willLast.bikeDueDate;
        dispatch(setBikeDueDate({ bikeDueDate }));

        const estimatedHeight = getDueHeight(bike);
        dispatch(setEstimatedHeight({ estimatedHeight }));

        dispatch(setBike({ bike }));        

        // dispatch(setEmailDataDatabase({ emailData: bike }))
        return database.ref(`user_${id}/bike`).update(bikeOptions)
    }
};

const setColorDatabase = (event, bike) => {

    return (dispatch, getValue) => {    
        
        let color;

        // if new color was picked set selected and save changes
        if (event) {
            color = event.target.attributes.getNamedItem('data-color').value;
            bike.color = color;
            dispatch(setBikeDatabase({ bike }));       
        } else {
            color = bike.color;
        }      
        
        let isColorExist = false;

        const currState = getValue();
        const date = currState.user.date;

        document.querySelectorAll('.color').forEach((item) => {
            if (item.attributes.getNamedItem('data-color').value === color) {
                item.classList.add('active');
                isColorExist = true;
            } else {
                item.classList.remove('active');
            }
        });

        // if color not exist set first and save changes
        if (!isColorExist) {
            document.querySelectorAll('.color')[0].classList.add('active');
            color = bike.colors[0];
            // bike.color = color;
            // dispatch(setBikeDatabase({ bike }));    
        }

        if (date) {
            const willLast = new Estimation(date, currState.bike.bike.height).getWillLast(currState.bike.bike, currState.bike.unit, color);
            dispatch(setBikeWillLast({ willLast }))
        }        

        bike.color = color;
        dispatch(setBikeDatabase({ bike }));   
        dispatch(setColor({ color }));

        // return database.ref(`user_${id}/events/colors`).push({ color })
    }
};

const setRange = (rangeValue, unit) => {

    const bike = matchCurrentBike(rangeValue, unit);

    return (dispatch, getValue) => {

        const color = getValue().bike.bike.color;

        bike.color = color;

        dispatch(setBike({ bike }));     
        dispatch(setColor({ color }));
        dispatch(setValue({ rangeValue }));

    }

};

const setRangeComplete = (rangeValue, unit, date) => {

    const bike = matchCurrentBike(rangeValue, unit);

    return (dispatch, getValue) => {

        const color = getValue().bike.bike.color;
        bike.color = color;     

        if (date) {
            const willLast = new Estimation(date, bike.height).getWillLast(bike, unit, color);
            dispatch(setBikeWillLast({ willLast }))
        }    
        
        dispatch(setBikeDatabase({ bike }));
        dispatch(setValue({ rangeValue }));
        dispatch(setUnitDatabase({ unit }));  
        dispatch(setColorDatabase(undefined, bike));
        
    }
    
};

const setFirstBike = (unit, date) => {

    const rangeValue = formatRange(unit, minRiderHeight, inchToCMIndex);

    const bike = searchService.defaultBike();

    bike.color = bike.colors[0];

    return (dispatch) => {

        if (date) {
            const willLast = new Estimation(date, bike.height).getWillLast(bike, unit, bike.colors[0]);
            dispatch(setBikeWillLast({ willLast }))
        }     

        dispatch(setBikeDatabase({ bike }));
        dispatch(setValue({ rangeValue }));   
        dispatch(setColorDatabase(undefined, bike))   
    }

};

const setInputComplete = (event, unit, date) => {

    const currentMax = formatRange(unit, maxRiderHeight, inchToCMIndex);

    let rangeValue = event.target.value > currentMax ? currentMax : Number(event.target.value);

    event.target.value = rangeValue;

    const bike = matchCurrentBike(rangeValue, unit);

    return (dispatch, getValue) => {

        const color = getValue().bike.bike.color;
        bike.color = color;       
        
        if (date) {
            const willLast = new Estimation(date, bike.height).getWillLast(bike, unit, color);
            dispatch(setBikeWillLast({ willLast }))
        }        

        dispatch(setBikeDatabase({ bike }));
        dispatch(setValue({ rangeValue }));
        dispatch(setUnitDatabase({ unit }));
        dispatch(setColorDatabase(undefined, bike));

    }

};

export {
    setRange,
    setLink,
    setLinkDatabase,
    setRangeComplete,
    setInputComplete,
    setFirstBike,
    setBike,
    setFinalBike,
    setBikeDueDate,
    setBikeDueDateNum,
    setEstimatedHeight,
    setEstimatedHeightNum,
    setNextBike,
    setBikeDatabase,
    setValue,
    setColor,
    setColorDatabase,
    setBikeWillLast,
    setUnit,
    setUnitDatabase,
    trackSegmentBike
};


// WEBPACK FOOTER //
// ./src/redux/actions/BikeActions.js